import Vue from 'vue'
import App from './App.vue'

import firebase from 'firebase'
import router from './router'
import VueAnalytics from 'vue-analytics'
import Ads from 'vue-google-adsense'

Vue.config.productionTip = false

const isProd = process.env.NODE_ENV == 'production'

Vue.use(VueAnalytics, {
    id: 'UA-45735211-8',
    router,
    debug: {
        enabled: !isProd,
        sendHitTask: isProd
    }
})
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)

var firebaseConfig = {
    apiKey: "AIzaSyBDoYyEfdM4SmiMDKtij6q88C46lPgPa8o",
    authDomain: "q-gaeyou-com.firebaseapp.com",
    databaseURL: "https://q-gaeyou-com.firebaseio.com",
    projectId: "q-gaeyou-com",
    storageBucket: "q-gaeyou-com.appspot.com",
    messagingSenderId: "701455416398",
    appId: "1:701455416398:web:209c2d56a6d91ab308971f"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
